module.exports = __webpack_public_path__ + "media/images/emblems/Doppleschwand_LU-70f969225bad5e5a0c94cc6fa326fd2a.png";